export default "__VITE_ASSET__B6J0gED0__"